import React from "react";
import styled from "styled-components";

const Background = styled.div`
  position: absolute;
  height: 200px;
  width: 200px;
  transform: rotate(10deg);
  img {
    height: 100%;
    width: auto;
    animation: mymove 4s linear infinite;
  }
`;

const drives = [
  "../../data/png/Digital Delay.png",
  "../../data/png/Flanger.png",
  "../../data/png/Distortion.png",
  "../../data/png/TurboOverDrive.png",
  "../../data/png/Group 135.png",
];

export const Background1: React.FC = () => {
  return (
    <div>
      {drives.map((value) => {
        <Background>
          <img src={require("../../data/png/Digital Delay.png").default} />
        </Background>;
      })}
    </div>
  );
};
